import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import { UploadDocResponse } from 'store/modules/models/uploadDocResponse';
import {
  CraApiResponse,
  CadastroCraApiRequest,
  GETInstrumentosFilterParams,
  HistoricoResponse,
  SolicitarLiquidacaoRequest,
  CommandResultTyped,
} from 'common/genericTypes';
import { errorMessages } from 'common/errorMessages.strings';
import { AditamentoDiferenca, AditamentoRevisionData } from 'components/aditamentoModal/aditamentoRevisionModal';

export const GETCraDetalhes = async (
  dispatch: Dispatch,
  id: string,
  stackRequest: boolean = false
): Promise<CraApiResponse> => {
  return await request(
    () => axiosInstance.get<CraApiResponse>(`${requestConfig.api}api/v1/cras/${id}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCras = async (
  dispatch: Dispatch,
  params?: GETInstrumentosFilterParams,
  stackRequest: boolean = false
): Promise<Array<CraApiResponse>> => {
  return await request(
    () => axiosInstance.get<Array<CraApiResponse>>(`${requestConfig.api}api/v1/cras`, params ? { params } : undefined),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCraByInstrumentoId = async (
  dispatch: Dispatch,
  instrumentoId: string,
  stackRequest: boolean = false
): Promise<CraApiResponse> => {
  return await request(
    () => axiosInstance.get<CraApiResponse>(`${requestConfig.api}api/v1/cras/instrumento-financeiro/${instrumentoId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTCra = async (dispatch: Dispatch, cra: CadastroCraApiRequest, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.post<CraApiResponse>(`${requestConfig.api}api/v1/cras`, cra),
    dispatch,
    errorMessages.instrumentoFinanceiro.generic,
    stackRequest
  );
};

export const PUTCra = async (
  dispatch: Dispatch,
  craId: string,
  cra: CadastroCraApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.put<CraApiResponse>(`${requestConfig.api}api/v1/cras/${craId}`, cra),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTCraAditamento = async (
  dispatch: Dispatch,
  craId: string,
  cra: CadastroCraApiRequest,
  date: string,
  document: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();
  fileForm.append('file', document);
  fileForm.append('dataAditamento', date);
  fileForm.append('aditamento', JSON.stringify(cra));

  return await request(
    () =>
      axiosInstance.put<string>(`${requestConfig.api}api/v1/cras/aditamento/${craId}`, fileForm, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};


export const PUTEditarCra = async (
  dispatch: Dispatch,
  craId: string,
  cra: CadastroCraApiRequest,
  justificativa: string,
  document?: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();

  if (document) fileForm.append('file', document);
  fileForm.append('justificativa', justificativa);

  const craStringfyed = JSON.stringify(cra);
  fileForm.append('instrumentoFinanceiroRequest', craStringfyed);

  return await request(
    () =>
      axiosInstance.put<CommandResultTyped<string>>(`${requestConfig.api}api/v1/cras/editar/${craId}`, fileForm, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTUploadDoc = async (
  dispatch: Dispatch,
  craId: string,
  emissionType: string,
  file: File,
  stackRequest: boolean = false
) => {
  const data = new FormData();
  data.append('file', file);
  return await request<Array<UploadDocResponse>>(
    () =>
      axiosInstance.put<Array<UploadDocResponse>>(`${requestConfig.api}api/v1/cras/${craId}/document`, data, {
        params: {
          emissionType,
        },
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const DELETEUploadDoc = async (
  dispatch: Dispatch,
  craId: string,
  craDocumentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.delete(`${requestConfig.api}api/v1/cras/${craId}/document/${craDocumentId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCraDocumentDownloadUrl = async (
  dispatch: Dispatch,
  craId: string,
  craDocumentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.get<string>(`${requestConfig.api}api/v1/cras/${craId}/document/${craDocumentId}/download`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTInterOpCra = async (dispatch: Dispatch, cra: CadastroCraApiRequest, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.post<CraApiResponse>(`${requestConfig.api}api/v1/cras/transferencia-dvm`, cra),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTEnviarLiquidacao = async (
  dispatch: Dispatch,
  craId: string,
  craSolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<CraApiResponse>(
        `${requestConfig.api}api/v1/cras/${craId}/enviar-liquidacao`,
        craSolicitarLiquidacaoRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTConfirmarLiquidacaoCra = async (dispatch: Dispatch, craId: string, precoUnitarioLiquidacao: number, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.post<CraApiResponse>(`${requestConfig.api}api/v1/cras/${craId}/confirmar-liquidacao`,
      { precoUnitario: precoUnitarioLiquidacao },
      { headers: { 'Content-Type': 'application/json' } }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETHistoricoCra = async (dispatch: Dispatch, craId: string, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<Array<HistoricoResponse>>(`${requestConfig.api}api/v1/cras/${craId}/historico-de-alteracoes`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETAditamentoCra = async (dispatch: Dispatch, aditamentoId: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<AditamentoRevisionData>(`${requestConfig.api}api/v1/cras/aditamento/${aditamentoId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTAditamentoCra = async (dispatch: Dispatch, aditamentoId: string, diferenca: AditamentoDiferenca[], stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.put<Array<AditamentoDiferenca>>(`${requestConfig.api}api/v1/cras/aditamento/atualizar/${aditamentoId}`, diferenca),
    dispatch,
    undefined,
    stackRequest
  );
};